import React from 'react';
import { Stack } from '../../../../../../components/Stack/Stack';
import { Grid } from '../../../../../../components/Grid/Grid';
import { graphql } from '../../../../../../generated';
import { useMutationHandler } from '../../../../../../model/graphql';
import { FormForm } from '../../../../../../components/Form/FormForm';
import { t } from '../../../../../../locales/translate';
import { handleSuccess } from '../../../../../../model/notification';

interface Props {
  details: {
    orderId: string;
    noOfTickets: number;
    email: string;
    name?: string;
  };
  onClose: () => void;
  onSuccess: () => void;
}

const RESEND_TICKETS = graphql(`
  mutation ResendTickets($orderId: String!) {
    resendTickets(input: { orderId: $orderId }) {
      order {
        id
      }
    }
  }
`);

export function ResendEmailTickets({ details, onClose, onSuccess }: Props): JSX.Element {
  const [resendTickets, { loading }] = useMutationHandler(RESEND_TICKETS);

  return (
    <FormForm
      loading={loading}
      saveButtonTitle={t.model.resendTickets.resend}
      onSubmit={async () => {
        await resendTickets({ variables: { orderId: details.orderId } });
        handleSuccess(t.model.resendTickets.success);
        onSuccess();
      }}
      onClose={onClose}
      canSubmit={!!details.orderId}
    >
      <Stack size="16">
        <Stack size="sm">
          <p>{t.model.resendTickets.title}</p>
          <p>{t.model.resendTickets.subtitle}</p>
        </Stack>
        <Grid gap="xxs">
          {details?.name && (
            <>
              <p>{t.model.resendTickets.name}</p>
              <p className="bold">{details.name}</p>
            </>
          )}
          <p>{t.model.resendTickets.recipientEmailAddress}</p>
          <p className="bold">{details.email}</p>
          <p>{t.model.resendTickets.noOfTickets}</p>
          <p className="bold">{details.noOfTickets}</p>
        </Grid>
      </Stack>
    </FormForm>
  );
}
